import { staticText } from '../../../utils/translations/staticText';

export const moneyMaxTranslation = staticText({
  bank_gift: {
    _: `Bank Gift - On Top of Moneymax's`,
    zh: '產品禮遇',
  },
  apply_through: {
    _: 'Apply through Moneymax and choose from :count premium rewards',
  },
  apply_through_ci: {
    _: 'Apply through Moneymax and choose from <b>:count premium rewards:</b>',
  },
  apply_through_stk_bka: {
    _: 'Apply through Moneymax and choose from :count premium rewards (Actual Gift eligibility depends on the deposit amount provided in the terms and conditions)',
  },
  purchase_through: {
    _: 'Purchase through SingSaver and choose from :count premium rewards',
  },
  brand_take: {
    _: `Moneymax's take`,
    zh: 'Moneymax 產品分析',
  },
  brand_reward: {
    _: 'Moneymax Reward',
  },
  brand_reward_guidance: {
    _: 'Moneymax Reward',
  },
});
